import { render, staticRenderFns } from "./seasCustomer.vue?vue&type=template&id=f413cb20&"
import script from "./seasCustomer.vue?vue&type=script&lang=js&"
export * from "./seasCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports